module.exports = __webpack_public_path__ + "img/sub-iconhand.378e2c79.svg";